import { view, prop } from '@vscode/observables-react';
import { styles } from './styles.js';
import { TreeView } from './TreeView.js';
import type { ExplorerModel } from './ExplorerModel.js';
import { SearchInput } from './SearchInput.js';

export const LeftSidebar = view(
  {
    model: prop.const<ExplorerModel>(),
  },
  (reader, props) => {
    const tree = props.model.filteredTree.read(reader);
    return (
      <div style={styles.sidebar}>
        <div style={styles.sidebarHeader}>Explorer</div>
        <SearchInput model={props.model} />
        <div style={styles.sidebarContent}>
          <TreeView model={props.model} nodes={[tree]} depth={0} />
        </div>
      </div>
    );
  }
);
